export default __webpack_public_path__ + "static/28-global-platinum-card-bolder-11d372bad2ce19f19e7ca498bcd640c0.webp";